var React = require('react');

function Password (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"#414141","d":"M303.06 348.91l.1.09-24 27a24 24 0 0 1-17.94 8H224v40a24 24 0 0 1-24 24h-40v40a24 24 0 0 1-24 24H24a24 24 0 0 1-24-24v-78a24 24 0 0 1 7-17l161.83-161.83-.11-.35a176.24 176.24 0 0 0 134.34 118.09z","key":0}),React.createElement("path",{"fill":"rgb(124, 95, 166)","d":"M336 0a176 176 0 1 0 176 176A176 176 0 0 0 336 0zm48 176a48 48 0 1 1 48-48 48 48 0 0 1-48 48z","key":1})]));
}

Password.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Password;

Password.default = Password;
